import { Content } from "../../types/content.interface";

export const certificateData: Content[] = [
  {
    isDisplay: true,
    details: [
      {
        enText: "TOPCIT (Grade IV, 697 points)",
        krText: "TOPCIT (수준4, 697점)",
        date: "(2025.12)",
        isDisplay: true,
      },
      {
        enText: "Linux Master, Grade II",
        krText: "리눅스마스터 2급",
        date: "(2024.12)",
        isDisplay: true,
      },
      {
        enText: "AWS Certified Solutions Architect - Associate(AWS SAA)",
        krText: "AWS Certified Solutions Architect - Associate(AWS SAA)",
        date: "(2024.11)",
        isDisplay: true,
      },
      {
        enText: "SQL Developer(SQLD)",
        krText: "SQL 개발자(SQLD)",
        date: "(2023.10)",
        isDisplay: true,
      },
      {
        enText: "Industrial Engineer Information Processing",
        krText: "정보처리산업기사",
        date: "(2022.11)",
        isDisplay: true,
      },
      {
        enText: "Internet security expert, Grade II",
        krText: "인터넷보안전문가 2급",
        date: "(2021.12)",
        isDisplay: true,
      },
    ],
  },
];
